import { useQuery } from '@tanstack/react-query';
import { fetchImageBlob } from '@/api/client-notes';

interface UseNoteImageParams {
  clientId: number;
  noteId: string;
  imageId: string;
  thumb?: boolean;
  enabled?: boolean;
}

export function useNoteImage({
  clientId,
  noteId,
  imageId,
  thumb = false,
  enabled = true,
}: UseNoteImageParams) {
  return useQuery({
    queryKey: ['note-image', clientId, noteId, imageId, thumb],
    queryFn: async () => {
      const blob = await fetchImageBlob(clientId, noteId, imageId, thumb);
      return URL.createObjectURL(blob);
    },
    enabled,
    staleTime: Infinity, // Images don't change
    gcTime: 1000 * 60 * 30, // Keep in cache for 30 minutes
  });
}
